import {useState} from 'react';
import {Banner} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';
import {useTranslatableResource} from 'features/Translations/TranslatableResource/hooks/useTranslatableResource';
import {useUrl} from '@web-utilities/url';
import {TranslatableResourceType} from 'types';
import {useShopLocalesAndMarkets} from 'utilities/use-shop-locales-and-markets';
import {useUrlParams} from 'utilities/use-url-params';

export const NoBaseTranslationsBanner = () => {
  const [i18n] = useI18n();
  const urlHelper = useUrl();
  const {resourceDisplayTitle, resourceType} = useTranslatableResource();
  const {currentLocale} = useShopLocalesAndMarkets();
  const {setUrlParams} = useUrlParams();
  const [show, setShow] = useState(true);

  return show ? (
    <Banner
      title={
        [
          TranslatableResourceType.OnlineStoreThemeJsonTemplate,
          TranslatableResourceType.OnlineStoreThemeSectionGroup,
          TranslatableResourceType.OnlineStoreThemeSettingsCategory,
          TranslatableResourceType.OnlineStoreThemeLocaleContent,
          TranslatableResourceType.OnlineStoreThemeSettingsDataSections,
        ].includes(resourceType)
          ? i18n.translate('NoBaseTranslationsBanner.themeTitle', {
              language: currentLocale.name,
            })
          : i18n.translate('NoBaseTranslationsBanner.title', {
              language: currentLocale.name,
              resourceDisplayTitle,
            })
      }
      action={{
        content: i18n.translate('NoBaseTranslationsBanner.editTranslations', {
          language: currentLocale.name,
        }),
        onAction: () => {
          setUrlParams({
            shopLocale: currentLocale.locale,
            market: undefined,
          });
        },
      }}
      secondaryAction={{
        content: i18n.translate('NoBaseTranslationsBanner.learnMore'),
        url: urlHelper.helpCenterUrl({
          locale: i18n.locale,
          path: 'manual/markets/languages',
        }),
        external: true,
        target: '_blank',
      }}
      onDismiss={() => setShow(false)}
      tone="warning"
    >
      <p>{i18n.translate('NoBaseTranslationsBanner.description')}</p>
    </Banner>
  ) : null;
};
